import * as actions from './actions'
import * as getters from './getters'
import * as types from './types'

const state = {
  equipmentSn: [], // sn号
  equipmentArray: [] // 硬件配件列表
}

const mutations = {
  [types.SET_EQUIPMENT_SN] (state, data) {
    state.equipmentSn = data
  },
  [types.SET_EQUIPMENT_ARRAY] (state, data) {
    state.equipmentArray = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
